import api, { getOAuthCallbackOrigin } from './client';

// Bank consents (Integrations -> Bank consents panel).
// Backend: routes/bank_consents.py, services/bank_consent_state.py.
//
// startReconsent takes the `reconsent` descriptor the backend attached to the
// row, so the button never has to know which provider it is renewing. The
// backend returns an auth_url; the caller redirects the browser to it.
export const bankConsentsAPI = {
  get: () => api.get('/integrations/bank-consents'),

  startReconsent: (reconsent) => {
    if (!reconsent || !reconsent.path || reconsent.method === 'MANUAL') {
      return Promise.reject(new Error(reconsent?.note || 'This connection has no self-service re-consent flow.'));
    }
    const params = { ...(reconsent.params || {}), origin: getOAuthCallbackOrigin() };
    Object.keys(params).forEach((k) => {
      if (params[k] === null || params[k] === undefined || params[k] === '') delete params[k];
    });
    if (reconsent.method === 'GET') {
      return api.get(reconsent.path, { params });
    }
    return api.post(reconsent.path, null, { params });
  },
};
